import { useState } from 'react';

export const useRemoveConfirmDialog = onConfirm => {
  const [removeResourceIndex, setRemoveResourceIndex] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const openDialog = index => {
    setRemoveResourceIndex(index);
    setIsDialogOpen(true);
  };

  const closeDialog = () => {
    setIsDialogOpen(false);
  };

  const handleConfirm = () => {
    onConfirm(removeResourceIndex);
    setRemoveResourceIndex(null);
    closeDialog();
  };

  return { isDialogOpen, openDialog, closeDialog, handleConfirm };
};
